import React, { Component } from 'react'
import './index.less'

export default class index extends Component {
  render() {
    return (
      <div>
        <div className="ludo-rule-content">
          <div className="ludo-rule-items">
            <div className="ludo-rule-content-title">MOVING OUT OF NEST</div>
            <div className="ludo-rule-content-pic">
              <img src="/img/ludo/rule1.png" alt="" />
            </div>
            <div className="ludo-rule-content-desc">
              Atakeoff will take place when you roll a six. Rolling a
              six also gives you an extra turn to roll the dice.
            </div>
          </div>
          <div className="ludo-rule-items">
            <div className="ludo-rule-content-title">MOVING OUT OF NEST</div>
            <div className="ludo-rule-content-pic">
              <img src="/img/ludo/rule1.png" alt="" />
            </div>
            <div className="ludo-rule-content-desc">
              Atakeoff will take place when you roll a six. Rolling a
              six also gives you an extra turn to roll the dice.
            </div>
          </div>
        </div>
        <div className="ludo-rule-desc">
          WINNING  THE  GAME
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/ludo/ludorule/Classic/index.js